import { Button, styled } from '@mui/material'

export interface StyledToolbarButtonProps {
  selected?: boolean
  disabled?: boolean
}

export const StyledToolbarButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<StyledToolbarButtonProps>(({ theme, selected, disabled }) => ({
  minWidth: 0,
  padding: theme.spacing(0.75),

  '&.MuiButtonGroup-grouped': {
    marginLeft: 0,
    marginRight: 0,
  },

  '&.Mui-disabled': {
    pointerEvents: 'auto',
    cursor: 'not-allowed',
  },

  ...(selected && {
    backgroundColor: theme.palette.action.selected,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  }),

  ...(disabled && {
    cursor: 'not-allowed',
  }),
}))
